export default __webpack_public_path__ + "media/images/theme_apple/backButton2-88e6c977cc238c561428110c1356664b.png";